module.exports = __webpack_public_path__ + "img/otp.ca971715.png";